import {handleActions, combineActions} from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "./invoiceActions";
import {userLogoutReceived} from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  invoices: [],
  drafts: [],
  archive: [],
  error: '',
  invoicingResults: {presentTense: '', pastTense: '', results: []},
  selectedInvoiceId: ''
});

const invoiceReducer = handleActions(
  {
    [combineActions(Actions.fetchAllInvoicesRequested, Actions.sendInvoicesRequested,
      Actions.addInvoiceItemRequested, Actions.removeInvoiceItemRequested, Actions.fetchInvoiceRequested, Actions.deleteInvoicesRequested,
      Actions.printInvoiceRequested, Actions.editInvoiceItemRequested,  Actions.postInvoiceRequested,
      Actions.fetchDraftInvoicesRequested, Actions.fetchInvoicesRequested, Actions.fetchArchivedInvoicesRequested)](state, action) {
      return state
        .set("isFetchingData", true)
        .set("error", "")
    },
    [combineActions(Actions.createInvoicesFailed, Actions.fetchAllInvoicesFailed, Actions.sendInvoicesFailed,
      Actions.addInvoiceItemFailed, Actions.removeInvoiceItemFailed, Actions.fetchInvoiceFailed, Actions.emailInvoicesFailed, Actions.deleteInvoicesFailed, Actions.printInvoiceFailed,
      Actions.editInvoiceItemFailed, Actions.postInvoiceFailed,
      Actions.archiveInvoicesFailed, Actions.fetchDraftInvoicesFailed, Actions.fetchInvoicesFailed, Actions.fetchArchivedInvoicesFailed)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", Immutable.fromJS(action.payload))
    },
    [combineActions(Actions.sendInvoicesReceived, Actions.addInvoiceItemReceived, Actions.editInvoiceItemReceived, Actions.removeInvoiceItemReceived,
      Actions.postInvoiceReceived)](state, action) {
      return state
        .set("isFetchingData", false)
    },
    [Actions.sendInvoicesReceived](state, action) {
      return state
        .set("isFetchingData", false)
    },
    [combineActions(Actions.fetchAllInvoicesReceived, Actions.fetchInvoicesReceived)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("invoices", Immutable.fromJS(action.payload))
    },
    [combineActions(Actions.createInvoicesRequested, Actions.deleteInvoicesRequested, Actions.archiveInvoicesRequested,Actions.emailInvoicesRequested,)](state, action) {
      return state
        .set("isFetchingData", true)
        .set("error", "")
        .set("invoicingResults", initialState.get('invoicingResults'))
    },
    [combineActions(Actions.createInvoicesReceived, Actions.deleteInvoicesReceived, Actions.archiveInvoicesReceived, Actions.emailInvoicesReceived,)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("invoicingResults", Immutable.fromJS(action.payload))
    },
    [Actions.setSelectedInvoice](state, action) {
      return state
        .set("selectedInvoiceId", action.payload)
    },
    [Actions.unSetSelectedInvoice](state, action) {
      return state
        .set("selectedInvoiceId", '')
    },
    [Actions.fetchInvoiceReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .update("invoices", invoices => {
          const index = invoices.findIndex(invoice => invoice.get("invoiceId") === action.payload.invoiceId)
          if (index >= 0) {
            return invoices.set(index, Immutable.fromJS(action.payload))
          } else {
            return invoices.push(Immutable.fromJS(action.payload))
          }
        })
    },
    [Actions.emailInvoicesReceived](state, action) {
      return state
        .set("isFetchingData", false)
    },
    [Actions.printInvoiceReceived](state, action) {
      return state
        .set("isFetchingData", false)
    },
    [Actions.unsetInvoiceError](state, action) {
      return state
        .set("error", '')
    },
    [Actions.clearInvoicingResults](state, action) {
      return state
        .set("invoicingResults", initialState.get('invoicingResults'))
    },
    [userLogoutReceived](state, action) {
      return initialState
    },
    [Actions.fetchDraftInvoicesReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("drafts", Immutable.fromJS(action.payload))
    },
    [Actions.fetchArchivedInvoicesReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("archive", Immutable.fromJS(action.payload))
    },
  },
  initialState
);

export {invoiceReducer, initialState};


// WEBPACK FOOTER //
// ./src/features/invoice/store/invoiceReducer.js